
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/host-watch-party",
      function () {
        return require("private-next-pages/mahashivratri/host-watch-party/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/host-watch-party"])
      });
    }
  